/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */

import { AppLoader } from "@advapacs/common";
import axios from "axios";
import React, { FC, useEffect, useState } from "react";

export interface ViewImageProps {
  src: string;
  unload?: boolean;
  dataSrc?: string;
}

const ViewImage: FC<ViewImageProps> = ({ src, unload, dataSrc }) => {
  const [base64, setBase64] = useState("");
  const [loading, setLoading] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [missingPixel, setMissingPixel] = useState(false);

  useEffect(() => {
    if (!src) {
      return;
    }
    const fetchImage = async () => {
      try {
        setLoading(true);
        const rs = await axios.get(src, {
          responseType: "blob", // had to add this one here
        });
        const url = window.URL.createObjectURL(new Blob([rs.data]));
        setBase64(url);
        setLoading(false);
      } catch (error) {
        if (error?.response && error?.response?.data instanceof Blob) {
          error.response.data
            .text()
            .then((e) => {
              const errorData = JSON.parse(e);
              if (errorData.code === "2107") {
                setMissingPixel(true);
              }
            })
            .catch(() => {});
        }
        setLoading(false);
        setBase64("");
      }
    };
    if (!unload) {

      fetchImage();
    }
  }, [src, unload]);
  return (
    <div className="w-100" style={{ height: 350 }}>
      <AppLoader.ViewerLoader
        isShowNoViewer={!loading && missingPixel}
        loading={loading}
        className="pp-viewer-loader"
        dark={true}
      >
        <img
          className={`lazy-image card-img img-fluid img-fit-contain ${
            loaded ? "loaded" : ""
          }`}
          src={base64}
          data-src={dataSrc}
          alt=""
          loading="lazy"
          onLoad={() => setLoaded(true)}
        />
      </AppLoader.ViewerLoader>
    </div>
  );
};
export default ViewImage;
